// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"189": "f9b8ea6b570a81f4","26": "892673f23e2b4c30",}[chunkId] + ".js"
}